<template>
  <!-- Umlagerung mobil (Trello 21.08.): technisch exakt wie der Desktop-Dialog, Teilmengen erlaubt -->
  <div class="m-wms-form">
    <m-wms-inventory-picker v-model="entry" />

    <div class="m-wms-form__field" @click="numPadOpen = true">
      <label>{{ $t("mobile.wms.quantity") }} *</label>
      <input :value="quantity || ''" readonly :placeholder="$t('mobile.wms.quantityPlaceholder')" />
    </div>
    <p v-if="quantityError" class="m-wms-form__error">{{ quantityError }}</p>

    <m-wms-location-field v-model="location" :label="$t('mobile.wms.targetLocation')" />

    <div class="m-wms-actions">
      <button class="m-wms-actions__cancel" @click="$router.push('/m/lager')">{{ $t("mobile.wms.cancel") }}</button>
      <button class="m-wms-actions__save" :disabled="!canSave || saving" @click="save">{{ $t("mobile.wms.save") }}</button>
    </div>

    <m-num-pad v-if="numPadOpen" :title="$t('mobile.wms.quantity')" :initial="quantity" @confirm="setQuantity" @close="numPadOpen = false" />
  </div>
</template>

<script>
import WarehouseService from "@/services/warehouse.service";
import MNumPad from "../components/MNumPad.vue";
import MWmsLocationField from "./MWmsLocationField.vue";
import MWmsInventoryPicker from "./MWmsInventoryPicker.vue";

export default {
  name: "MUmlagerung",
  components: { MNumPad, MWmsLocationField, MWmsInventoryPicker },
  data() {
    return { entry: null, quantity: null, quantityError: null, location: null, numPadOpen: false, saving: false };
  },
  computed: {
    canSave() {
      return !!(this.entry && this.quantity > 0 && !this.quantityError && this.location);
    },
  },
  watch: {
    entry() {
      this.validateQuantity();
    },
  },
  methods: {
    setQuantity(value) {
      this.quantity = value;
      this.validateQuantity();
    },
    validateQuantity() {
      // Nicht mehr als der gewaehlte Eintrag hergibt (Trello 21.08.) - der Server prueft zusaetzlich
      this.quantityError = this.entry && this.quantity > this.entry.inventory ? this.$t("mobile.wms.quantityTooHigh", { max: this.entry.inventory }) : null;
    },
    async save() {
      if (!this.canSave || this.saving) return;
      this.saving = true;
      try {
        const res = await WarehouseService.moveGoods({
          warehouseInventoryId: this.entry.id,
          quantity: this.quantity,
          storageLocationId: this.location.id,
        });
        if (res.data && res.data.status === "error") {
          this.$notify({ timeout: 3500, message: this.$t(`wms.messages.${res.data.message}`, res.data.metadata), horizontalAlign: "right", verticalAlign: "top", type: "danger" });
          return;
        }
        this.$notify({ timeout: 2500, message: this.$t("wms.messages.created"), horizontalAlign: "right", verticalAlign: "top", type: "success" });
        this.$router.push("/m/lager");
      } catch (err) {
        this.$notify({ timeout: 3500, message: this.$t("mobile.wms.saveError"), horizontalAlign: "right", verticalAlign: "top", type: "danger" });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./m-wms.scss"></style>
